exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".emoji[data-v-949ed830]{vertical-align:top}.messageinput[data-v-949ed830]{width:calc(100% - 110px)!important;float:left!important;height:38px!important}.discuss-thread-container[data-v-949ed830]{padding-bottom:25px}.chat-input-controls[data-v-949ed830]{margin-bottom:10px;width:100%}@media (max-width:768px){.chat-input-controls[data-v-949ed830]{margin-bottom:20px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-949ed830","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/discuss/discuss-singlethread.vue
// module id = 1173
// module chunks = 0